import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField, DropDownMenu, MenuItem } from 'material-ui';

import './clientInfo.css';
import '../../../grid.css';

class ClientInfo extends Component {
    static propTypes = {
        isLocked: PropTypes.bool.isRequired,
        selectedState: PropTypes.number.isRequired,
        companyName: PropTypes.string.isRequired,
        street: PropTypes.string.isRequired,
        street2: PropTypes.string.isRequired,
        Zip: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        country: PropTypes.string.isRequired,
        setClientInfoSelectedState: PropTypes.func.isRequired,
        setCompanyName: PropTypes.func.isRequired,
        setClientInfoStreet: PropTypes.func.isRequired,
        setClientInfoZip: PropTypes.func.isRequired,
        setClientInfoCity: PropTypes.func.isRequired,
        updateClientStatus: PropTypes.func.isRequired,
        setCountry: PropTypes.func.isRequired,
        setClientInfoStreet2: PropTypes.func.isRequired,
    };

    handleChange(value) {
        const { setClientInfoSelectedState, updateClientStatus } = this.props;
        setClientInfoSelectedState(value);
        updateClientStatus(null);
    }

    handleclientNameChange(value) {
        const { setCompanyName, updateClientStatus } = this.props;
        setCompanyName(value);
        updateClientStatus(null);
    }

    handleStreetChange(value) {
        const { setClientInfoStreet, updateClientStatus } = this.props;
        setClientInfoStreet(value);
        updateClientStatus(null);
    }

    handleStreet2Change(value) {
        const { setClientInfoStreet2, updateClientStatus } = this.props;
        setClientInfoStreet2(value);
        updateClientStatus(null);
    }

    handleCityChange(value) {
        const { setClientInfoCity, updateClientStatus } = this.props;
        setClientInfoCity(value);
        updateClientStatus(null);
    }

    handleZipChange(value) {
        const { setClientInfoZip, updateClientStatus } = this.props;
        setClientInfoZip(value);
        updateClientStatus(null);
    }
    handleCountryChange(value) {
        const { setCountry, updateClientStatus } = this.props;
        setCountry(value);
        updateClientStatus(null);
    }

    render() {
        const {
            selectedState, companyName, street, street2, isLocked, Zip, city, country,
        } = this.props;

        return (
            <div className="col span-1-of-2">
                <h1>Main Address</h1>
                <TextField
                    autoFocus
                    margin="dense"
                    floatingLabelText="Company's Legal Name if Applicable"
                    defaultValue={companyName}
                    onChange={(e, value) => this.handleclientNameChange(value)}
                    disabled={isLocked}
                    fullWidth
                />
                <TextField
                    floatingLabelText="Address"
                    defaultValue={street}
                    onChange={(e, value) => this.handleStreetChange(value)}
                    disabled={isLocked}
                    fullWidth
                />

                <TextField
                    floatingLabelText="Address 2"
                    defaultValue={street2}
                    onChange={(e, value) => this.handleStreet2Change(value)}
                    disabled={isLocked}
                    fullWidth
                />

                <TextField
                    floatingLabelText="City"
                    defaultValue={city}
                    onChange={(e, value) => this.handleCityChange(value)}
                    disabled={isLocked}
                    fullWidth
                />

                <DropDownMenu
                    fullWidth
                    label="State"
                    value={selectedState}
                    onChange={(e, index, value) => this.handleChange(value)}
                    disabled={isLocked}
                >
                    <MenuItem value="1" primaryText="California" />
                    <MenuItem value="2" primaryText="Massachusetts" />
                    <MenuItem value="3" primaryText="New Jersey" />
                    <MenuItem value="4" primaryText="Florida" />
                    <MenuItem value="5" primaryText="New York" />
                </DropDownMenu>

                <TextField
                    floatingLabelText="Zip"
                    defaultValue={Zip}
                    onChange={(e, value) => this.handleZipChange(value)}
                    disabled={isLocked}
                    fullWidth
                />

                <DropDownMenu
                    fullWidth
                    label="Country"
                    value={country}
                    onChange={(e, index, value) => this.handleCountryChange(value)}
                    disabled={isLocked}
                >
                    <MenuItem value="USA" primaryText="United States of America" />
                    <MenuItem value="other" primaryText="Other" />
                </DropDownMenu>
            </div>
        );
    }
}

export default ClientInfo;



// WEBPACK FOOTER //
// ./src/containers/AddClient/ClientInfo/ClientInfo.js